
import {Component, Vue,Prop} from 'vue-property-decorator';
import {IPage} from "@/js/page";
import {integrityApi} from "@/api/integrity";
import SetTableColumns from "@/components/SetTableColumns.vue"
import {dictApi, dictInstrumentApi, userApi} from "@/api/organization";
import baseUrl from '@/constants';
import Credit from "@/views/integrity/Credit.vue";
import ApplyDialog from "@/views/integrity/applyDialog.vue";
const {regionData,CodeToText} =require("@/js/region/region");
@Component({
  name: "integrityList",
  components: {ApplyDialog, Credit, SetTableColumns}
})

export default class Home extends Vue {

  @Prop() private status!: number;
  regionData = regionData;
  CodeToText = CodeToText;
  title = "诚信计量新建业务";
  listData = [];
  listParam: IPage = {
    size: 10,
    current: 1,
  };
  listTotal = 0;
  listTotal0 = "";
  modeType = "0";
  screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  tabCol = [];
  showForm = false;
  form = {
    state: this.status,  //业务状态
    orgName: "",  //单位名称
    typeId: "", //行业类别
    region: "", //所在区域
    userName: "",  //发起人
    mobile: "",  //联系电话
    start: "", //公示日期开始时间
    end: "", //公示日期结束时间
  } as any
  tableKey = 0;
  userData = {} as any;
  allSelected = [];
  statesList = [];  //行业类别

  created() {
    this.userData = this.$store.state.AuthedUser;
    const route = this.$route;
    const q = JSON.parse(JSON.stringify(route.query));
    if(q.modeType){
      this.modeType = q.modeType;
    }
    if(q.size){
      this.listParam.size = Number(q.size);
      this.listParam.current = Number(q.current);
    }
    this.getConfig();
    this.getDict()
  }
  activated(){
    if (this.$route.meta && !this.$route.meta.isBack) {
      this.showForm = false;
      this.reset();
    }else{
      this.list(this.modeType);
    }
  }
  getConfig() {
    userApi.getUserConfig({name: "auditPageSize"}).then(r => {
      if (r.data.result == 0) {
        const rData = r.data.data;
        if (rData) {
          this.listParam.size = Number(rData.config);
        }
        this.list("0");
        if(this.modeType == "1"){
          this.list("1");
        }
      }
    })
  }
  changeTabCol(e: any) {
    this.tabCol = e;
    this.$nextTick(()=>{
      let $table = this.$refs.table as HTMLFormElement;
      if($table){
        $table.doLayout();
      }
      this.tableKey = Math.random();
    })
  }

  handleClick() {
    this.refresh();
  }

  indexMethod(index: any) {
    return (this.listParam.current - 1) * this.listParam.size + index + 1;
  }


  reset(){
    for(const f in this.form){
      this.form[f] = "";
    }
    this.refresh();
  }
  refresh() {
    //this.showForm = false;
    this.listParam.current = 1;
    this.list();
  }

  list(modeType: string = this.modeType) {
    this.tableClearSelect();
    const route = this.$route;
    let q = JSON.parse(JSON.stringify(route.query));
    q = Object.assign(q,{modeType: this.modeType}, this.listParam);
    for (const key in q) {
      q[key] = String(q[key]);
    }
    const params = {
      ...this.listParam,
      ...this.form,
      submitType: modeType?modeType:this.modeType,
    }
    integrityApi.list(params).then(r => {
      if(r.data.result == 0){
        const rData = r.data.data;
        if(this.modeType == modeType){
          this.listData = rData.records;
          this.listTotal = rData.total;
        }
        if(modeType == "0"){
          this.listTotal0 = rData.total;
        }
        this.$nextTick(()=>{
          let $table = this.$refs.table as HTMLFormElement;
          if($table){
            $table.doLayout();
          }
        })
      }
    })
  }

  pageSizeChange(val: number) {
    this.listParam.size = val;
    this.refresh();
    userApi.updateUserConfig({name: "auditPageSize", config: val})
  }
  pageCurrentChange(val: number) {
    this.listParam.current = val;
    this.list();
  }
  add() {
    this.$router.push("/qj/audit/detail/0/0");
  }
  memberSelect(selection: any, row: any) {
    this.allSelected = selection;
  }
  tableClearSelect(){
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    if($table){
      $table.clearSelection();
    }
  }
  toDetail(row: any, type: string) {
    (this.$refs.applyDialog as any).toDetail(row, type);
  }
  getDict(){
    return dictApi.listDictItem({
      typeCode: "hylb"
    }).then(r=>{
      if(r.data.result === 0){
        this.statesList = r.data.data;

      }
    })
  }
}
